import { render, staticRenderFns } from "./WorktimeWeeklyReleaseEdit.vue?vue&type=template&id=366eab36"
import script from "./WorktimeWeeklyReleaseEdit.vue?vue&type=script&lang=js"
export * from "./WorktimeWeeklyReleaseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports